'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _sortBy = require('lodash/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _toPairs = require('lodash/toPairs');

var _toPairs2 = _interopRequireDefault(_toPairs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var deserializeDocument = function deserializeDocument(_ref) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { react: true };

  var data = _ref.data,
      metadata = _objectWithoutProperties(_ref, ['data']);

  var deserializedFields = deserializeFields(data, options);

  return _extends({}, metadata, mapFieldsToObject(deserializedFields));
};

var deserializeFields = function deserializeFields(fields, options) {
  return (0, _toPairs2.default)(fields).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return {
      key: key,
      value: deserializeField(value, options)
    };
  });
};

var isSlice = function isSlice(value) {
  return (0, _isArray2.default)(value) && value.length > 0 && value[0].slice_type;
};
var isGroup = function isGroup(value) {
  return (0, _isArray2.default)(value) && value.length > 0 && !value[0].type;
};

var deserializeField = function deserializeField(value, options) {
  if (isSlice(value)) {
    return value.map(function (slice) {
      return {
        type: slice.slice_type,
        label: slice.slice_label,
        primary: mapFieldsToObject(deserializeFields(slice.primary, options)),
        items: slice.items.map(function (item) {
          return mapFieldsToObject(deserializeFields(item, options));
        })
      };
    });
  } else if (isGroup(value)) {
    return value.map(function (group) {
      var deserializedFields = deserializeFields(group, options);
      return mapFieldsToObject(deserializedFields);
    });
  } else {
    return value;
  }
};

var mapFieldsToObject = function mapFieldsToObject(fields) {
  return (
    // turn into an object, respecting nested keys e.g. about-myTitle = about.myTitle
    (0, _sortBy2.default)(fields, ['key']).reduce(function (data, _ref4) {
      var key = _ref4.key,
          value = _ref4.value;

      var keyParts = key.split('.');
      var keyName = keyParts.length > 1 ? keyParts[1] : keyParts[0];
      var nestedStructure = keyName.split('-').join('.');
      return (0, _set2.default)(data, nestedStructure, value);
    }, {})
  );
};

exports.default = deserializeDocument;


//////////////////
// WEBPACK FOOTER
// ../~/prismic-utils/dist/deserialize/index.js
// module id = 475
// module chunks = 0